import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, Heading, Text } from "@nbs/ui";

export function ForbiddenPage() {
  const { t } = useTranslation();
  const location = useLocation();
  const from =
    typeof location.state === "object" &&
    location.state &&
    "from" in location.state &&
    typeof (location.state as { from?: unknown }).from === "string"
      ? (location.state as { from: string }).from
      : null;

  return (
    <section className="nbs-page-state" data-testid="forbidden-page">
      <span className="nbs-bare__glyph" aria-hidden="true">
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
          <rect
            x="4"
            y="10"
            width="16"
            height="11"
            rx="2.5"
            stroke="currentColor"
            strokeWidth="1.6"
          />
          <path d="M8 10V7a4 4 0 0 1 8 0v3" stroke="currentColor" strokeWidth="1.6" />
          <circle cx="12" cy="15.5" r="1.4" fill="currentColor" />
        </svg>
      </span>
      <Heading level={1}>{t("pages.forbiddenTitle")}</Heading>
      <Text tone="muted">{t("pages.forbiddenBody")}</Text>
      {from ? <Text tone="muted">{t("pages.forbiddenFrom", { path: from })}</Text> : null}
      <div className="nbs-login-page__actions">
        <Link to="/dashboard">
          <Button variant="primary">{t("nav.dashboard")}</Button>
        </Link>
        <Link to="/">
          <Button variant="secondary">{t("pages.goHome")}</Button>
        </Link>
      </div>
    </section>
  );
}
